import Logger from "@/helpers/logger";

/**
 * Returns true if the referral feature is enabled (4th bit in partnerState is set).
 */
export const isReferralEnabled = partnerState => {
  return (partnerState & (1 << 3)) !== 0; // 4th bit indicates referral feature
};

/**
 * Handles opening the Cello SDK. If the SDK is not available, logs an error and shows a toast message.
 * @param {Function} showToast - Function to display a toast message.
 * @param {String} errorMessage - Translated error message to display in the toast.
 */
export const handleCelloOpen = (showToast, errorMessage) => {
  if (window.Cello) {
    window.Cello("open");
  } else {
    Logger.error("Cello SDK not available on window when attempting to open referral hook.");
    showToast(errorMessage);
  }
};
